

      jQuery(document).ready(function(){ 
        $('.sticky-bar-form').hide(); 
        

        $(".product-single__variant").on('change', function()
                                         {
          var data= $(this).val();
          $('.product-single__variants').val(data).trigger('change');  

          var option = $('option:selected', this).attr('data-title');
          var option = option.split(" / ");
          // ********************************option1
          var variant1 = option[0];
          variant1 =  $.trim(variant1);
          $('.myvariantclass1 .variant-input-wrap select').val(variant1).trigger('change'); 

          // ********************************option2
          if(option[1] == null)
          {
          }
          else
          {
            var variant2 = option[1];
            variant2 =  $.trim(variant2);
            $('.myvariantclass2 .variant-input-wrap select').val(variant2).trigger('change'); 
          }
          // ********************************option3
          if(option[2] == null)
          {
          }
          else
          {
            var variant3 = option[2];
            variant3 =  $.trim(variant3);
            $('.myvariantclass3 .variant-input-wrap select').val(variant3).trigger('change');  
          }
          // ********************************option3  


        });

           

      }); 